import enLocale from './en'
export default {
  ...enLocale,
  language: 'Idioma',
  confirm: 'Confirmar',
  go: 'Ir',
  status: 'Estado',
  balance: 'Saldo',
  cash: 'Efectivo',
  createNew: 'Crear nuevo',
  home: 'Inicio',
  market: 'Mercado',
  markets: 'Mercados',
  portfolio: 'Portafolio',
  license: 'Licencia',
  withdraw: 'Retirar',
  auditChecking: 'Revisión en curso',
  insufficientFunds: 'Fondos insuficientes',
  buy: 'Comprar',
  history: 'Historial',
  seeMore: 'Ver más',
  theme: 'Tema',
  network: 'Red',
  walletBalance: 'Saldo de la cartera',
  collect: 'Cobrar',
  approve: 'Aprobar',
  ticket: 'Licencia',
  category: 'Categoría',
  sortBy: 'Ordenar por',
  issue: 'Publicar',
  detail: 'Detalle',
  stakingType: 'Garantía',
  stakingTypeInfo: 'Para evitar confirmaciones maliciosas, stakea tokens o el NFT actual.',
  subscriptionAmount: 'Cantidad de compra',
  subscription: 'Suscripción',
  subscribe: 'Comprar',
  max: 'Máx',
  marketClosed: 'Mercado cerrado',
  deposit: 'Añadir',
  verifiedNFT: 'Verificar licencia',
  select: 'Seleccionar',
  selected: 'Seleccionado',
  moreNFT: 'Obtener más licencias',
  forecastEvent: 'Evento',
  subscribeEndDate: 'Última hora de negociación',
  specifyExpiryDate: 'Especificar hora de vencimiento',
  endDate: 'Hora de fin',
  validityPeriod: 'Hora de vencimiento',
  marketEndDate: 'Hora de vencimiento',
  liquidityMin: 'Liquidez mínima',
  premiumMin: 'Mín. prima',
  paymentCurrency: 'Moneda de pago',
  defaultOdds: 'Apalancamiento por defecto',
  setDefaultOdds: 'Configurar apalancamiento',
  minInvestAmout: 'Establecer inversión mínima',
  depositMargin: 'Añadir liquidez',
  totalPayment: 'Pago total',
  rewards: 'Recompensas',
  rewardRate: 'Tasa de recompensa',
  release: 'Liberar',
  fee: 'Tarifa',
  marginFeeRate: 'Tasa de tarifa',
  cdsInfoOne: 'Para publicar, stakea margen, fija apalancamiento y mínimo.',
  cdsInfoTwo: 'Margen no participante retirable en cualquier momento.',
  cdsInfoThree: 'Si más de uno apela, inicia gobernanza.',
  deposited: 'Invertido',
  issued: 'Publicado',
  depositedCDS: 'productos invertidos',
  totalProfit: 'Ganancia total',
  allOrDeposited: 'Total/Invertido',
  rewardsOrProfit: 'Recompensas/Ganancia',
  estimatedInvested: 'Estimado/Invertido',
  profit: 'Ganancia',
  yesterdayProfit: 'Ganancia ayer',
  eventConfirming: 'Confirmando evento',
  appeal: 'Impugnar',
  appealing: 'Impugnando',
  appealFailed: 'Impugnación fallida',
  occured: 'Ocurrido',
  notOccured: 'No ocurrido',
  governanceMechanism: 'Gobernanza si >1 impugnación.',
  appealLimit: 'No más de una impugnación.',
  waitResult: 'Esperando resultado',
  frozenMargin: 'Margen congelado',
  marginBalance: 'Saldo de margen',
  endTime: 'Cuenta regresiva',
  guaranteeing: 'En curso',
  guaranteeingEvent: 'Predicción en curso',
  confirmsEventAdvance: 'Confirmado anticipadamente',
  waitConfirmation: 'Esperando confirmación',
  triggerEvent: 'Evento confirmado como ocurrido',
  notTriggerEvent: 'Evento no ocurrió',
  defaultChallenging: 'Ocurrido — impugnación',
  notDefaultChallenging: 'No ocurrido — impugnación',
  defaultChallengeFailed: 'Ocurrido — impugnación falló',
  notDefaultChallengeFailed: 'No ocurrido — impugnación falló',
  defaultWaitingResult: 'Ocurrido — gobernanza en espera',
  notDefaultWaitingResult: 'No ocurrido — gobernanza en espera',
  defaultGovernanceMechanism: 'Ocurrido — gobernanza confirmó',
  notDefaultGovernanceMechanism: 'No ocurrido — gobernanza confirmó',
  cancel: 'Cancelar',
  defaultAhead: 'Anticipado',
  occur: 'Ocurrir',
  notOccur: 'No ocurrir',
  stakingToChallenge: 'Stake para impugnar',
  challenged: 'Impugnado',
  checking: 'Verificando',
  fail: 'Fallo',
  appealInfoOne: 'Si el fallo es erróneo, «Impugnar» para gobernanza.',
  check: 'Verificar',
  contentIllegal: 'Contenido ilegal, edita antes de publicar',
  subscribed: 'Productos invertidos',
  receivingCompensation: 'Pendiente',
  received: 'Pago total',
  receive: 'Recibir',
  compensationAmount: 'Monto de compensación',
  liquidity: 'Liquidez',
  injectLiquidity: 'Inyectar liquidez',
  uRLContent: 'URL/Contenido',
  resolutionSource: 'Fuente de resolución',
  textareaInfo: 'Describe brevemente el evento.',
  share: 'Compartir',
  USDT: 'USDT',
  donations: 'Donaciones',
  issueMsgPleaseSelectLicense: 'Por favor selecciona una licencia',
  issueMsgLicenseCannotBeStaked: 'La licencia no puede stakearse',
  issueMsgNetworkNotConnected: 'Red no conectada',
  issueMsgEventEmpty: 'Evento vacío',
  issueMsgSelectLicense: 'Selecciona una licencia',
  issueMsgLastTradingDateEmpty: 'La última hora de negociación está vacía',
  issueMsgExpirationDateEmpty: 'La hora de vencimiento está vacía',
  issueMsgLastTradingDateGreaterThanToday: 'La última hora de negociación debe ser mayor que hoy',
  issueMsgLastTradingDateGreaterThanExpirationDate: 'La última hora de negociación es mayor que la hora de vencimiento',
  issueMsgEventEndDateGreaterThanRentalEndDate: 'La hora de fin del evento {eventEndDate} es mayor que la hora de fin del alquiler {rentalEndDate}',
  issueMsgOptionsEmpty: 'Las opciones no pueden estar vacías',
  issueMsgOptionsLessThanTwo: 'Al menos dos opciones',
  issueMsgOptionEmpty: 'Contenido de opción vacío',
  issueMsgOptionRepeated: 'Contenido de opción duplicado',
  issueMsgLastTradingDateGreaterThanToday: 'Último día debe ser después de hoy',
  issueMsgLastTradingDateGreaterThanExpirationDate: 'Último día mayor que expiración',
  issueMsgLicenseError: 'Error de licencia',
  issueMsgTicketError: 'Error de ticket',
  issueMsgEventEndDateGreaterThanRentalEndDate: 'Fin {eventEndDate} > fin de alquiler {rentalEndDate}',
  issueMsgInsufficientBalance: 'Saldo insuficiente',
  issueMsgTransactionFailed: 'Transacción fallida',
  issueMsgIssueSuccess: 'Publicación exitosa',
  issueMsgTransactionCancelled: 'Transacción cancelada',
  short: {
    confirmsEventAdvance: 'Anticipado',
    waitConfirmation: 'En espera de confirmación',
    defaultChallenging: 'Ocurrido — impugnación',
    notDefaultChallenging: 'No ocurrido — impugnación',
    defaultChallengeFailed: 'Ocurrido — impugnación fallida',
    notDefaultChallengeFailed: 'No ocurrido — impugnación fallida',
    defaultWaitingResult: 'Ocurrido — gobernanza',
    notDefaultWaitingResult: 'No ocurrido — gobernanza',
    defaultGovernanceMechanism: 'Ocurrido — gobernanza confirmó',
    notDefaultGovernanceMechanism: 'No ocurrido — gobernanza confirmó'
  },
  wallet: {
    openWallet: 'Abrir cartera',
    connectWallet: 'Conectar cartera',
    connectingWallet: 'Conectando cartera',
    connectYourWallet: 'Conecta tu cartera',
    disconnect: 'Desconectar',
    wrongNetwork: 'Red incorrecta'
  },
  NFT: {
    getPrediLicense: 'Obtener licencia Predi',
    referralRewards: 'Recompensas por referidos',
    mintYourLicence: 'Mintear licencia',
    usageRights: 'Derechos de uso',
    issuePredictionProducts: 'Publicar productos de predicción',
    governance: 'Gobernanza',
    properties: 'Propiedades',
    tradable: 'Comerciable',
    rentable: 'Alquilable',
    usable: 'Usable',
    marketsToIssue: 'Mercados a publicar',
    times: 'Veces',
    availableTimes: 'Veces disponibles',
    ticketId: 'ID del ticket',
    cancelRentHint: 'Licencia en alquiler, cancélala para vender.',
    sell: 'Vender',
    rent: 'Alquilar',
    share: 'Compartir',
    USDT: 'USDT',
    common: 'Común',
    scarcity: 'Escasez',
    attributive: 'Atributivo',
    numbers: 'Núm. de emisión',
    issueTip: 'Emitir 10 mercados/licencias',
    price: 'Precio',
    success: 'Éxito',
    getNFT: 'Licencia obtenida',
    issueCDS: 'Publicar mercados Predi',
    buyNow: 'Comprar ahora',
    mintNow: 'Mintear ahora',
    rule: 'Regla',
    comingSoon: '¡Próximamente!',
    type: 'Tipo',
    from: 'De',
    to: 'A',
    me: 'Yo',
    rented: 'Alquilado',
    sold: 'Vendido',
    tabGetLicense: 'Obtener licencia',
    tabMyLicense: 'Mi licencia',
    bought: 'Comprado',
    boughtProducts: 'Productos comprados',
    investedProducts: 'Productos invertidos',
    issuedProducts: 'Productos publicados',
    positions: 'Posiciones',
    options: 'Opciones',
    all: 'Todos',
    volume: 'Volumen',
    newest: 'Más nuevo',
    price: 'Precio',
    pending: 'Pendiente',
    audit: 'Revisión',
    loading: 'Cargando',
    home: 'Inicio',
    market: 'Mercado',
    markets: 'Mercados',
    portfolio: 'Portafolio',
    license: 'Licencia',
    empowering: 'Empoderando visionarios que predicen el futuro',
    myPositions: 'Mis posiciones',
    challengeCredit: 'Crédito de impugnación',
    challengeStatus: 'Estado de impugnación',
    succeed: 'Exitoso',
    wait: 'Esperar',
    return: 'Retorno',
    createYourOwnMarket: 'Crear tu propio mercado',
    waitChallenge: 'Evento esperando impugnación.',
    waitingGovernanceResult: 'Evento esperando gobernanza.',
    eventFinished: 'Evento finalizado.',
    cancelled: 'Cancelado',
    predictionProduct: 'Producto de predicción',
    complaintCountdown: 'Cuenta regresiva de queja',
    setResult: 'Establecer resultado',
    challenge: 'Impugnar',
    recycleTicket: 'Reciclar ticket',
    eventCancelled: 'El evento ha sido cancelado.',
    auditChecking: 'Revisión en curso',
    insufficientFunds: 'Fondos insuficientes',
    buyTicket: 'Comprar ticket',
    buy: 'Comprar',
    listYourToken: 'Listar tu token',
    setResultModalTitle: 'Establecer resultado:',
    cancelModalTitle: 'Cancelar',
    cancelIrreversible: 'La cancelación es irreversible.',
    challengeModalTitle: 'Impugnación',
    challengeStakeIntro: 'Si se desvía del hecho, se reembolsará.',
    challengeStakeButton: 'PRDS para impugnar',
    history: 'Historial',
    seeMore: 'Ver más',
    licenses: 'Licencias',
    prediLicense: 'Licencia Predi',
    issuableQuantity: 'Cantidad emitible',
    disabled: 'Deshabilitado',
    battleImage: 'Imagen',
    upload: 'Subir',
    showSample: 'Ver ejemplo',
    battleInformation: 'Información',
    baseToken: 'Token base',
    collateral: 'Colateral',
    currentLicense: 'Licencia actual',
    predictionProject: 'Proyecto de predicción:',
    issueExpireIntro: 'En la hora de vencimiento, quienes hayan elegido la opción correcta compartirán los tokens del pool del producto según su participación.',
    issueConfirmAdvance: 'El emisor puede confirmar el resultado por adelantado si el evento ocurre antes de la hora de vencimiento.',
    issueChallengeWithin7Days: 'Impugnar dentro de 7 días.',
    issueAttention: 'Predi es entretenimiento/social. Prohibido el juego.',
    eventSampleTitle: 'Evento',
    issueSampleCrypto: '[Cripto] ¿Rango de precio de BTC a fin de 2025?',
    issueSampleFinance: '[Finanzas] ¿Decisión de tasas de la Fed en Q3 2025?',
    issueSampleTechnology: '[Tecnología] ¿Quién lanzará el primer robot asistente IA autónomo?',
    issueSampleSports: '[Deportes] ¿Qué equipo ganará el Mundial 2026?',
    issueSampleSociety: '[Sociedad] ¿Qué plataforma tendrá más MAU en 2025?',
    issueSampleOthers: '[Otros] ¿Cuándo terminará la guerra Rusia-Ucrania?',
    issuerResult: 'Resultado del emisor',
    daoResult: 'Resultado DAO',
    predictionToken: 'Token de predicción',
    issuer: 'Emisor',
    issuerProfit: 'Ganancia del emisor'
  },
  claim: {
    title: 'Reclama PRDs gratis',
    subtitle: 'Obtén tus PRDs con un clic',
    walletAddress: 'Dirección de cartera',
    status: 'Estado',
    connectWalletFirst: 'Conecta la cartera primero',
    eligibility: {
      claimed: 'Ya reclamado',
      eligible: 'Elegible para reclamar',
      error: 'Error al verificar elegibilidad'
    },
    button: {
      claim: 'Reclamar',
      alreadyClaimed: 'Ya reclamado',
      connect: 'Conectar'
    },
    footerNotice: 'Cada cartera solo una vez. Verifica la red correcta.',
    messages: {
      connectFirst: 'Conecta tu cartera primero',
      claimSuccess: '¡Reclamado con éxito!',
      claimFailed: 'Fallido, inténtalo más tarde',
      txCancelled: 'Transacción cancelada',
      onlyOnce: 'Cada usuario solo una vez',
      insufficientBalance: 'Saldo de contrato insuficiente, intenta más tarde'
    }
  },
  
  // Additional top-level keys from en.js
  inputSearchText: 'Por favor ingresa contenido de búsqueda',
  predictionProduct: 'Producto de predicción',
  listYourToken: 'Listar tu token',
  description: 'Descripción',
  positions: 'Posiciones',
  options: 'Opciones',
  all: 'Todos',
  volume: 'Volumen',
  newest: 'Más nuevo',
  pending: 'Pendiente',
  audit: 'Revisión',
  loading: 'Cargando',
  challengeCredit: 'Crédito de impugnación',
  challengeStatus: 'Estado de impugnación',
  succeed: 'Exitoso',
  wait: 'Esperar',
  return: 'Retorno',
  waitChallenge: 'Evento esperando impugnación.',
  complaintCountdown: 'Cuenta regresiva de queja',
  setResult: 'Establecer resultado',
  issueParticipateUntil: 'Participación hasta',
  specifyLastTradingDate: 'Especificar última hora de negociación',
  empowering: 'Empoderando visionarios que predicen el futuro',
  amount: 'Cantidad',
  createYourOwnMarket: 'Crear tu propio mercado'
}